module.exports = __webpack_public_path__ + "img/ski_train2.17fb8cb1.png";